'use client'

import { SessionProvider } from 'next-auth/react'
import { useEffect } from 'react'

export function NextAuthSessionProvider({ children, session }) {
  useEffect(() => {
    console.log('🔄 SessionProvider: Initializing NextAuth session provider', {
      hasInitialSession: !!session,
      sessionData: session ? {
        user: session.user ? {
          email: session.user.email,
          name: session.user.name,
          provider: session.user.provider,
          hasFacebookToken: !!session.user.facebookAccessToken
        } : null,
        expires: session.expires
      } : null,
      timestamp: new Date().toISOString()
    });
  }, [session]);

  return (
    <SessionProvider 
      session={session}
      onUpdate={(session) => {
        console.log('🔄 SessionProvider: Session updated', {
          hasSession: !!session,
          sessionData: session ? {
            user: session.user ? {
              email: session.user.email,
              name: session.user.name,
              provider: session.user.provider,
              hasFacebookToken: !!session.user.facebookAccessToken
            } : null,
            expires: session.expires
          } : null,
          timestamp: new Date().toISOString()
        });
      }}
    >
      {children}
    </SessionProvider>
  )
}